import fetcher from "../helpers/fetcher";

export async function GetAllDevices(
  page,
  searchTerm = "",
  campaginID = "",
  tagID = "",
  locationId = "",
  partnerID = "",
  networkName = "",
  countyName = "",
  cityName = "",
  sortField = "",
  sortDirection = "asc"
) {
  let path = `/devices?page=${page}&search=${searchTerm}&campaign_id=${campaginID}&tag_id=${tagID}&location_id=${locationId}&partner_id=${partnerID}&network_name=${networkName}&county_name=${countyName}&city_name=${cityName}&sort_field=${sortField}&sort_direction=${sortDirection}`;

  let request = await fetcher(path, "GET");

  let content = request.json();

  return content;
}

export async function GetVideosByDeviceID(device_id, page, searchTerm = "") {
  let path = `/videos/device/${device_id}?page=${page}&search=${searchTerm}`;

  let request = await fetcher(path, "GET");

  let content = request.json();

  return content;
}

export async function GetAllDeviceNames() {
  let path = "/all-device-names";

  let request = await fetcher(path, "GET");

  let content = await request.json();

  return content;
}

export async function UpdateDeviceName(body, device_id) {
  let path = `/devices/update-name/${device_id}`;

  let request = await fetcher(path, "PUT", body);

  let content = await request.json();

  return content;
}

export async function AddOrUpdateDeviceObservations(body, device_id) {
  let path = `/devices/observations/${device_id}`;

  let request = await fetcher(path, "PUT", body);

  let content = await request.json();

  return content;
}

export async function UpdateDeviceWorkSchedule(body, device_id) {
  let path = `/devices/update-work-schedule/${device_id}`;

  let request = await fetcher(path, "PUT", body);

  let content = await request.json();

  return content;
}

export async function SendDataForLoop(body) {
  let path = "/devices/save-loop";

  let request = await fetcher(path, "POST", body);

  let content = await request.json();

  return content;
}

export async function HandleToggleTV(device_id, isTVOff) {
  const path = `/devices/tv-command/${device_id}`;
  const command = isTVOff ? "tv_on" : "tv_off";
  const body = JSON.stringify({ command });

  let response = await fetcher(path, "POST", body);
  let content = await response.json();
  return content;
}

export async function HandleRebootDevice(device_id) {
  const path = `/devices/reboot/${device_id}`;

  let response = await fetcher(path, "POST");
  let content = await response.json();
  return content;
}

export async function ExportDevicesToExcel({
  searchTerm,
  filterTags,
  filterLocations,
  filterPartners,
  filterCampaigns,
}) {
  const body = {
    searchTerm,
    filterTags,
    filterLocations,
    filterPartners,
    filterCampaigns,
  };

  const path = "/devices/export";
  const response = await fetcher(path, "POST", JSON.stringify(body));

  if (!response.ok) {
    throw new Error("Failed to export Excel");
  }

  const blob = await response.blob();
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = "devices_export.xlsx";
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}
